import styled from 'styled-components';

export const DigitalWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
`;
